import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {type V4Response} from './api-base.type';
import {V4HttpClient} from './v4-http.client';

/** 主 region（US）公开 API。版本检查与 iot-admin 固件目录同一 host。 */
const PRIMARY_REGION_API_BASE_URL = 'https://api.mangopower.com';

export interface SystemAppUpdateInfo {
  id?: string;
  name?: string;
  version?: string;
  min_version?: string;
  remark?: string;
  created_at?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SystemApiService {
  private readonly v4Http = inject(V4HttpClient);

  async checkUpdate(): Promise<V4Response<SystemAppUpdateInfo>> {
    return this.v4Http.post<SystemAppUpdateInfo>(
      `${PRIMARY_REGION_API_BASE_URL}/v4/system/check-update`,
      {app_id: environment.appId},
      {silentError: true},
    );
  }
}
